import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(ElementUI)

import '@/assets/icon/iconfont.css'
import App from './App.vue'
import router from './router'
import store from './store'
import './permission'
import './assets/styles/element-ui.scss'
import './assets/styles/index.scss'
import 'echarts'
import ECharts from 'vue-echarts'
import dayjs from 'dayjs';

import VueCompositionAPI from "@vue/composition-api";
Vue.use(VueCompositionAPI);



Vue.component('v-chart', ECharts)

import { selectDictLabel } from '@/utils/dict'

Vue.prototype.selectDictLabel = selectDictLabel

import Pagination from "@/components/Pagination";
Vue.component('Pagination', Pagination)

import _ from 'lodash';
Vue.prototype._ = _;
Vue.prototype.dayjs = dayjs;
// Vue.prototype.$imgURL=`https://yujinxiang.test03.qcw800.com`; // 图片路径



import {
  webKey,
  securityJsCode
} from './utils/mapConfig'



window._AMapSecurityConfig = {
  securityJsCode
}
import AMapLoader from "@amap/amap-jsapi-loader";
Vue.use(AMapLoader)

import VueAMap from 'vue-amap'
Vue.use(VueAMap)
VueAMap.initAMapApiLoader({
  key: webKey,
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor', 'AMap.Geolocation'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
  uiVersion: '1.0.11',
})

// import VueAMap, {initAMapApiLoader} from '@vuemap/vue-amap';
// import '@vuemap/vue-amap/dist/style.css';
// // 初始化vue-amap
// initAMapApiLoader({
//   // 高德的key
//   key: webKey,
//   securityJsCode: securityJsCode, // 新版key需要配合安全密钥使用
//   //Loca:{
//   //  version: '2.0.0'
//   //} // 如果需要使用loca组件库，需要加载Loca
// });
// Vue.use(VueAMap)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
